import type {
  CommentAuthor,
  CommentMessage,
  CommentTarget,
  CommentThread
} from "./types.js";

export interface CreateCommentThreadInput {
  target: CommentTarget;
  body: string;
  author: CommentAuthor;
  now?: string;
  threadId?: string;
  messageId?: string;
}

export interface ReplyToCommentThreadInput {
  threadId: string;
  body: string;
  author: CommentAuthor;
  now?: string;
  messageId?: string;
}

export interface ThreadPermissionContext {
  actorClientId: string;
  now?: string;
}

export function createCommentThread(input: CreateCommentThreadInput): CommentThread {
  const now = input.now ?? new Date().toISOString();

  return {
    id: input.threadId ?? crypto.randomUUID(),
    owner: input.author,
    target: input.target,
    status: "active",
    createdAt: now,
    updatedAt: now,
    messages: [
      {
        id: input.messageId ?? crypto.randomUUID(),
        author: input.author,
        body: input.body,
        createdAt: now
      }
    ]
  };
}

export function createCommentReply(input: ReplyToCommentThreadInput): CommentMessage {
  return {
    id: input.messageId ?? crypto.randomUUID(),
    author: input.author,
    body: input.body,
    createdAt: input.now ?? new Date().toISOString()
  };
}

export function canManageCommentThread(
  thread: Pick<CommentThread, "owner">,
  actorClientId: string
): boolean {
  return thread.owner.clientId === actorClientId;
}

export function getCommentSidecarPath(filePath: string): string {
  const slashIndex = filePath.lastIndexOf("/");
  const directory = slashIndex >= 0 ? filePath.slice(0, slashIndex + 1) : "";
  const fileName = slashIndex >= 0 ? filePath.slice(slashIndex + 1) : filePath;
  const baseName = fileName.endsWith(".md") ? fileName.slice(0, -3) : fileName;
  return `${directory}.${baseName}.obis`;
}
